import { useLayoutEffect, useRef, useState } from 'react'

import { readSvgMeta } from './useSvgMeta.utils'

export function useSvgMeta({ size }) {
  const svgRef = useRef(null)
  const [meta, setMeta] = useState(null)

  useLayoutEffect(() => {
    if (svgRef.current) {
      setMeta(readSvgMeta(svgRef.current, size))
    }
  }, [size])

  return {
    svgMeta: meta,
    svgRef,
  }
}
